import React, { useEffect } from "react"
import { Link } from "react-router-dom"
import { Container } from "reactstrap"
import SoldxHeader from "../../../../components/SoldxHeader"
import SoldxLandingFooter from "../../../../components/SoldxLandingFooter"
import { SupportPhonePair } from "../../../../components/SupportContactPhones"
import {
  SUPPORT_COMPANY_LEGAL_NAME,
  SUPPORT_EMAIL,
  SUPPORT_MAILTO,
} from "../../../../config/supportContact"
import "../TermsAndConditions.scss"

const AboutUs = () => {
  useEffect(() => {
    document.title = "About Us | SoldX"
  }, [])

  return (
    <div className="soldx-landing soldx-legal-page">
      <SoldxHeader solid />
      <main className="soldx-legal-main">
        <Container className="soldx-legal-container">
          <div className="soldx-legal-back-wrap">
            <Link to="/" className="soldx-legal-back">
              <i className="mdi mdi-arrow-left me-1" aria-hidden />
              Back to home
            </Link>
          </div>

          <div className="soldx-legal-card">
            <header className="soldx-legal-card-header">
              <h1 className="soldx-legal-card-title">About Us</h1>
            </header>
            <div className="soldx-legal-card-body">
              <div className="soldx-legal-content">
                <section className="soldx-legal-section">
                  <p>
                    The demo content covers two main aspects that you should consider: it presents the strengths of
                    our theme, and it showcases the smart features we provide. We highly recommend referring to it as a
                    great inspiring starting point to see how much you can achieve with your upcoming website. If the
                    import process seems to stop, then you should know that it might be just a common WordPress issue
                    related to the maximum execution time exceeded. There is a plugin that you can use to fix this
                    easily. If you still struggle with it, read our friendly.
                  </p>
                </section>

                <section className="soldx-legal-section">
                  <h2>Let&apos;s Connect</h2>
                  <h3>Contact Us</h3>
                  <p className="soldx-legal-contact-block">
                    <strong>{SUPPORT_COMPANY_LEGAL_NAME}</strong>
                    <br />
                    Email:{" "}
                    <a href={SUPPORT_MAILTO} className="soldx-legal-link">
                      {SUPPORT_EMAIL}
                    </a>
                    <br />
                    Phone:{" "}
                    <SupportPhonePair linkClassName="soldx-legal-link" />
                    <br />
                    Gurugram, 122001
                  </p>
                </section>
              </div>
            </div>
          </div>
        </Container>
      </main>

      <SoldxLandingFooter />
    </div>
  )
}

export default AboutUs
